/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import {
    Container,
    Row,
    Card,
    CardBody,
    CardTitle,
    Col,
    Media,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Alert,
    FormText
} from 'reactstrap';
import {Link, Redirect} from "react-router-dom";

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../../translations/global.json";
/** End of Multiple Language imports **/
import LanguageManager from '../../custom-classes/language-manager';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons';
import PlatformDownloadList from '../item-list/platform-download-list';

// Component for subscriptions
class FormSubscriptionDownload extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                {name: "English", code: "en"},
                {name: "Español", code: "es"}
            ],
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage("en")}
        });
        this.props.addTranslation(global);

        this.state = {
            mobile: props.data.mobile,
            planId: null,
            validPlan: true, // default
            didMount: false,
            propsModal: null,
            showErrorModal: false,
            userSubscribed: false
        };

        this.saveSubscriptionState = this.saveSubscriptionState.bind(this);
    }

    componentWillReceiveProps(nextProps) {

        console.log("Next props download", nextProps)
        if (typeof nextProps.data !== "undefined" && nextProps.data.didMount) {
            this.setState({mobile: nextProps.data.mobile});
        }
    }

    saveSubscriptionState(subscriptionState){

        this.setState({userSubscribed: subscriptionState.userSubscribed, subscriptionId: subscriptionState.subscriptionId},()=>
        {
            this.props.updateParent(this.state);
            return this.state;
        });
    }


    /**
     * Renders the landing page
     * @returns {XML}
     */
    render() {
        return (
            <div>
                <div className="container-padding">
                    <Container className={this.state.mobile ? "margin-top-mandatory-60" : null}>
                        <Row>
                            <Col xs={{size: 4, offset: 4}} lg={{size: 2, offset: 5}}>
                                <Media src={require('../../img/user-icon-2.png')} alt="User icon" width="100%"/>
                            </Col>
                        </Row>
                        <Row className="text-center white-text">
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}
                                 className="text-center">
                                <h2 className="font-now-bold">
                                    <FontAwesomeIcon className="fa-1x" icon={faCheckCircle}/> {' '}
                                    <Translate id="subscription-steps.step-4" options={{renderInnerHtml: true}}/>
                                </h2>
                                <small>
                                    <Translate id="subscription-steps.step-4-subtitle"
                                               options={{renderInnerHtml: true}}/>
                                </small>
                                <hr/>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={{size: 12, offset: 0}} md={{size: 12, offset: 0}} lg={{size: 12, offset: 0}}>
                                <PlatformDownloadList />
                            </Col>
                        </Row>
                        <Row className="text-center white-text">
                            <Col sm={{size: 12, offset: 0}} md={{size: 12, offset: 0}} lg={{size: 12, offset: 0}}>
                            <Link className="btn btn-imp btn-danger btn-block font-now-bold" to="/dashboard">
                                <Translate id="subscription-steps.or-go-to-dashboard" options={{renderInnerHtml: true}}/>
                            </Link>
                            </Col>
                            <Col sm={{size: 12, offset: 0}} md={{size: 12, offset: 0}} lg={{size: 12, offset: 0}}>
                                <Translate id="subscription-steps.go-to-dashboard-title" options={{renderInnerHtml: true}}/>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        )
    };
}

export default withLocalize(FormSubscriptionDownload);


// WEBPACK FOOTER //
// ./src/components/forms/form-subscription-download.js